










































































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsPageLayout from "@/design-system/patterns/Page/JdsPageLayout.vue"
import JdsPageIntro from "@/design-system/patterns/Page/JdsPageIntro.vue"
import JdsPageTitle from "@/design-system/patterns/Page/JdsPageTitle.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsPageSection from "@/design-system/patterns/Page/JdsPageSection.vue"
import JdsPageSectionHeading from "@/design-system/patterns/Page/JdsPageSectionHeading.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsPageBackLink from "@/design-system/patterns/Page/JdsPageBackLink.vue"

@Component({
    components: {
        JdsPageBackLink,
        JdiDocs,
        JdsPageSectionHeading,
        JdsPageSection, JdsButton, JdsPageTitle, JdsPageIntro, JdsPageLayout, JdiPreview, JdiContent
    }
})
export default class Page extends Vue {
}
